import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-functions",
  templateUrl: "./med-icon-functions.component.html",
})
export class MedIconFunctionsComponent extends SvgMixinComponent {}
